import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

// Fetches live traffic incidents for an ordered list of [lat,lng] route points.
// Re-runs automatically whenever the points change (i.e. route recalculated).
export function useRouteIncidents(points, { snapToRoads = false, runId = null, enabled = true, showAll = false } = {}) {
  const [data, setData] = useState(null);
  const sig = useMemo(
    () => JSON.stringify(points || []) + String(snapToRoads) + String(runId) + String(enabled) + String(showAll),
    [points, snapToRoads, runId, enabled, showAll],
  );

  const refresh = useCallback(() => {
    if (!enabled || !points || points.length < 1) { setData(null); return; }
    api.post("/traffic/incidents", { points, snap_to_roads: snapToRoads, run_id: runId, show_all: showAll })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [sig]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { refresh(); }, [refresh]);
  return { data, refresh };
}
